import { Action, Selector, State, StateContext, StateToken } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { StateBase } from 'app/state/state-base';
import { JobsStatusService, JobStatus } from '../jobs-status.service';
import { JobsStatusActions } from './actions';
import { tap } from 'rxjs';

export interface JobsStatusStateModel {
  jobs: JobStatus[];
  count: number;
  page: number;
  per_page: number;
}

@State<JobsStatusStateModel>({
  name: new StateToken<JobsStatusStateModel>('jobsStatusState'),
  defaults: {
    jobs: [],
    count: 0,
    page: 1,
    per_page: 20,
  },
})
@Injectable()
export class JobsStatusState extends StateBase {
  constructor(private readonly jobsStatusService: JobsStatusService) {
    super();
  }

  @Selector()
  static getJobs(state: JobsStatusStateModel) {
    return state.jobs;
  }

  @Selector()
  static getJobsPage(state: JobsStatusStateModel) {
    return {
      jobs: state.jobs,
      count: state.count,
      page: state.page,
      per_page: state.per_page,
    };
  }

  @Action(JobsStatusActions.GetJobs)
  getJobs(context: StateContext<JobsStatusStateModel>, action: JobsStatusActions.GetJobs) {
    return this.jobsStatusService.getJobsStatus(action.page, action.per_page).pipe(
      tap((response) => {
        context.patchState({
          jobs: response.job_statuses,
          count: response.count || 0,
          page: action.page || 1,
          per_page: action.per_page || 20,
        });
      }),
    );
  }

  @Action(JobsStatusActions.JobUpdated)
  jobUpdated(context: StateContext<JobsStatusStateModel>, { id, job }: { id: number; job: Partial<JobStatus> }) {
    const state = context.getState();
    const updatedJobs = state.jobs.map((existingJob) => {
      if (existingJob.id === id) {
        return { ...existingJob, ...job };
      }
      return existingJob;
    });
    context.patchState({ jobs: updatedJobs });
  }

  @Action(JobsStatusActions.JobAdded)
  jobAdded(context: StateContext<JobsStatusStateModel>, { job }: { job: JobStatus }) {
    const state = context.getState();
    context.patchState({ jobs: [...state.jobs, job] });
  }
}

